import {
    HyruleApplication,
    HyruleComponentConfig,
    HyruleToken,
} from '@nintendo/hyrule-react-commons';
import React, { FunctionComponent, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import Container from 'react-bootstrap/Container';
import { ApolloClient, ApolloProvider, HttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import BackToTopButton from './components/shared/components/BackToTopButton';
import AppVersion from './components/shared/components/AppVersion';
import Header from './components/Header';
import HyruleTokenContext from './components/contexts/HyruleTokenContext';
import { SearchContextProvider } from './components/contexts/SearchContext';
import DiceEnvironmentConfig from './environment/config';
import { useNcomToken } from './components/contexts/useNcomToken';
import Home, { LEGACY_ROUTE_PREFIXES } from './components/Home';

const App: FunctionComponent = () => {
    const [hyruleToken, setHyruleToken] = useState({} as HyruleToken);
    const getNcomToken = useNcomToken();

    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                retry: 1,
                refetchOnWindowFocus: false,
            },
        },
    });

    const routes: HyruleComponentConfig[] = [
        {
            name: 'Home',
            path: '/',
            component: <Home />,
            scopes: null,
            exact: true,
        },
        {
            name: 'Home',
            path: `/(${LEGACY_ROUTE_PREFIXES.join('|')})/:idParam`,
            component: <Home />,
            scopes: null,
        },
    ];

    const authTokenCallback: (token: HyruleToken) => void = (token: HyruleToken) => {
        setHyruleToken(token);
    };

    const authLinkNCom = setContext(async (_, { headers }) => {
        const token = await getNcomToken();
        return {
            headers: {
                ...headers,
                'x-customer-token': token,
            },
        };
    });

    const httpLink = new HttpLink({
        uri: DiceEnvironmentConfig.getApiConfig().ncomGraphUrl,
        headers: {
            'x-nintendo-graph': 'true',
        },
    });

    const client = new ApolloClient({
        link: authLinkNCom.concat(httpLink),
        cache: new InMemoryCache(),
        name: 'warpzone',
        version: DiceEnvironmentConfig.getDiceEnv(),
    });

    return (
        <Container className="p-3" fluid>
            <HyruleTokenContext.Provider value={hyruleToken}>
                <QueryClientProvider client={queryClient}>
                    <SearchContextProvider>
                        <ApolloProvider client={client}>
                            <HyruleApplication
                                appName="WarpZone"
                                authTokenCallback={authTokenCallback}
                                defaultPath="/"
                                navHeaderCustom={Header}
                                tabs={[]}
                                routes={routes}
                            />
                        </ApolloProvider>
                    </SearchContextProvider>
                    <BackToTopButton />
                    <AppVersion />
                </QueryClientProvider>
            </HyruleTokenContext.Provider>
        </Container>
    );
};

export default App;
